var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useState } from 'react';
import { useFormikContext } from 'formik';
import { IconButton, InputAdornment, TextField } from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import CurrencyField from './CurrencyField';
import DecimalField from './DecimalField';
import PercentField from './PercentField';
import IntegerField from './IntegerField';
import getPropertyValueByStringPath from '../../../helpers/getPropertyValueByStringPath';
import { removeMask } from '../../../helpers/numberFunctions';
import { removeTime, formatDateAndTime } from '../../../helpers/dateTimeFunctions';
import './FormField.scss';
export var FormFieldTypes;
(function (FormFieldTypes) {
    FormFieldTypes[FormFieldTypes["TEXT"] = 0] = "TEXT";
    FormFieldTypes[FormFieldTypes["PASSWORD"] = 1] = "PASSWORD";
    FormFieldTypes[FormFieldTypes["DATE"] = 2] = "DATE";
    FormFieldTypes[FormFieldTypes["INTEGER"] = 3] = "INTEGER";
    FormFieldTypes[FormFieldTypes["PERCENT"] = 4] = "PERCENT";
    FormFieldTypes[FormFieldTypes["DECIMAL"] = 5] = "DECIMAL";
    FormFieldTypes[FormFieldTypes["CURRENCY"] = 6] = "CURRENCY";
    FormFieldTypes[FormFieldTypes["PHONE"] = 7] = "PHONE";
    FormFieldTypes[FormFieldTypes["DATEANDTIME"] = 8] = "DATEANDTIME";
})(FormFieldTypes || (FormFieldTypes = {}));
const FormField = (_a) => {
    var { helperText = '', name, type = FormFieldTypes.TEXT, unitLabel, maskoptions, onBeforeChange = (v) => v, inputProps = {} } = _a, 
    // autoselect = false,
    rest = __rest(_a, ["helperText", "name", "type", "unitLabel", "maskoptions", "onBeforeChange", "inputProps"]);
    const [showPassword, setShowPassword] = useState(false);
    const formik = useFormikContext();
    const error = getPropertyValueByStringPath(formik.errors, name);
    const touched = getPropertyValueByStringPath(formik.touched, name);
    let value = getPropertyValueByStringPath(formik.values, name);
    const numberTypes = [FormFieldTypes.INTEGER, FormFieldTypes.DECIMAL, FormFieldTypes.CURRENCY];
    function handleOnChange(e) {
        const value = onBeforeChange(e.target.value);
        if (numberTypes.indexOf(type) > -1) {
            formik.setFieldValue(name, removeMask(value));
        }
        else if (FormFieldTypes.PERCENT === type) {
            const unmaskedValue = removeMask(value);
            if (unmaskedValue != null && (unmaskedValue > 100 || unmaskedValue < 0)) {
                formik.setFieldValue(name, Math.max(Math.min(unmaskedValue, 100), 0));
            }
            else {
                formik.setFieldValue(name, unmaskedValue);
            }
        }
        else {
            formik.setFieldValue(name, value);
        }
    }
    function handleOnBlur() {
        formik.setFieldTouched(name);
    }
    let inputComponent;
    let inputType = 'text';
    if (type === FormFieldTypes.PASSWORD) {
        inputType = 'password';
    }
    else if (type === FormFieldTypes.DATE) {
        inputType = 'date';
        value = removeTime(value);
    }
    else if (type === FormFieldTypes.DATEANDTIME) {
        inputType = 'date';
        value = formatDateAndTime(value);
    }
    else if (type === FormFieldTypes.INTEGER) {
        inputComponent = IntegerField;
    }
    else if (type === FormFieldTypes.PERCENT) {
        inputComponent = PercentField;
        // eslint-disable-next-line no-param-reassign
        unitLabel = '%';
    }
    else if (type === FormFieldTypes.DECIMAL) {
        inputComponent = DecimalField;
    }
    else if (type === FormFieldTypes.CURRENCY) {
        inputComponent = CurrencyField;
    }
    return (React.createElement("div", { className: `form-field ${helperText ? 'has-helper-text' : ''}` },
        React.createElement(TextField, Object.assign({ type: showPassword ? 'text' : inputType, fullWidth: true, 
            // autoselect={autoselect}
            variant: "outlined", name: name, value: value || '', error: !!touched && !!error, 
            // helperText={touched && helperText}
            helperText: helperText || (touched && error), onChange: handleOnChange, onBlur: handleOnBlur, InputProps: {
                endAdornment: inputType === 'password' ? (React.createElement(InputAdornment, { position: "end" },
                    React.createElement(IconButton, { disableRipple: true, onClick: () => setShowPassword(!showPassword), edge: "end" }, showPassword ? React.createElement(Visibility, null) : React.createElement(VisibilityOff, null)))) : null,
                inputComponent,
            }, 
            // eslint-disable-next-line react/jsx-no-duplicate-props
            inputProps: Object.assign(Object.assign({}, inputProps), { maskoptions }) }, rest)),
        !!unitLabel && React.createElement("label", { className: "form-field-unit-label" }, unitLabel)));
};
export default FormField;
